import { types as t } from 'mobx-state-tree';

import ApplicationForm from './ApplicationForm';

export default t.model('JobLanguage', {
  language: t.string,
  title: t.string,
  shortDescriptionHtml: t.maybeNull(t.string),
  description: t.maybe(t.string),
  location: t.string,
  form: t.maybeNull(ApplicationForm),
});
